export default __webpack_public_path__ + "static/media/Untitled.fbc3292f.png";